import React from "react";

const DevilordPageCursed: React.FC = () => {
    return (
        <>
            <section style={{ height: "100%", fontFamily: "Times New Roman, Times, serif", padding: "20px", color: "#780606", textAlign: "center" }}>
                <h1>₩ɆⱠ₵Ø₥Ɇ ₮Ø ⱧɆⱠⱠ</h1>
                <p style={{ maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
                    You know them... but you are mine now...
                </p>
            </section>

        </>
    );
};

export default DevilordPageCursed;
